/**
 * DnsVerificationStep - Shared component for TXT/CNAME/A record verification steps
 */
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { DnsRecord } from '@/api/domainsApi';
import { DnsRecordDisplay, DnsRecordsListDisplay } from './DnsRecordDisplay';

interface DnsVerificationStepProps {
  /** Single record for TXT/CNAME */
  record?: DnsRecord;
  /** Multiple records for A records (apex + www) */
  records?: DnsRecord[];
  stepNumber?: number;
  error?: string | null;
  nameLabel?: string;
  valueLabel?: string;
  /** Additional note to display below the records */
  note?: string;
}

export const DnsVerificationStep: React.FC<DnsVerificationStepProps> = ({
  record,
  records,
  stepNumber = 1,
  error,
  nameLabel,
  valueLabel,
  note,
}) => {
  return (
    <div className="space-y-3">
      {record && (
        <DnsRecordDisplay
          record={record}
          nameLabel={nameLabel}
          valueLabel={valueLabel}
          recordId={`step-${stepNumber}`}
        />
      )}

      {records && records.length > 0 && (
        <DnsRecordsListDisplay records={records} />
      )}

      {note && (
        <p className="text-sm text-muted-foreground">{note}</p>
      )}

      {error && (
        <div className="flex items-center gap-2 text-sm text-amber-600">
          <AlertCircle className="h-3 w-3" />
          {error}
        </div>
      )}
    </div>
  );
};
